import { useMutation, useQueryClient } from '@tanstack/react-query';
import { recallReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { RecallReportDetail } from '@/types';
import { logger } from '@/utils/logger';

interface ResetPayload {
  reportId: number;
}

type ResetOptions = {
  onSuccess?: (data: RecallReportDetail) => void;
  onError?: (error: Error) => void;
};

export const useResetRecallReport = (options?: ResetOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }: ResetPayload) =>
      recallReportService.resetReport(reportId),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.recallReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to reset recall report:', error);
      options?.onError?.(error);
    },
  });
};
